import {Country} from "../defs/country";
import {CountryGroup} from "../defs/group";

export const BouvetIsland: Country = {
    identifier: "BouvetIsland",
    name: "Bouvet Island",
    countryCode: "BV",
    group: CountryGroup.OCEANIA,
    isUNMember: false,
    flag: "🇧🇻",
    svgPath: "m 484.61275,644.9594 -0.051,0.023 -0.127,-10e-4 -0.043,0.006 -0.063,0.047 -0.02,-0.02 -0.023,-0.036 -0.01,-0.094 0.028,-0.105 0.041,-0.049 0.072,-0.043 0.058,-0.025 0.056,-0.01 0.03,0.003 0.105,0.077 0.008,0.055 -0.016,0.068 -0.017,0.049 z",
}
